import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, computed, model, Signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { ActivityInterface } from '@vendasta/crm';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CrmFieldService, StandardIds } from '../../../../shared-services/crm-services/field.service';
import { TranslationModule } from '../../../../i18n/translation-module';
import { ActivityRichTextComponent } from '../../activities/activity-rich-text.component';

@Component({
  selector: 'crm-activity-logged-call-v2',
  templateUrl: './logged-call-v2.component.html',
  styleUrls: ['./logged-call-v2.component.scss'],
  providers: [],
  imports: [CommonModule, TranslateModule, TranslationModule, ActivityRichTextComponent],
})
export class CrmActivityLoggedCallV2Component {
  activity = model<ActivityInterface>({});
  callRecordingSource$: Observable<any>;

  cardInfo: Signal<ActivityCardInformation> = computed(() => {
    return {
      body: this.getStringFieldData(this.activity(), StandardIds.ActivityCallBody),
      outcome: this.getStringFieldData(this.activity(), StandardIds.ActivityCallOutcome),
      status: this.getStringFieldData(this.activity(), StandardIds.ActivityCallStatus),
      callRecordingUrl: this.getStringFieldData(this.activity(), StandardIds.ActivityCallRecordingUrl),
    };
  });

  private getStringFieldData(activity: ActivityInterface, fieldId: string): string {
    return this.fieldService.getFieldValueFromCrmObject(activity, fieldId)?.stringValue ?? '';
  }

  constructor(
    private readonly http: HttpClient,
    private readonly fieldService: CrmFieldService,
  ) {
    this.callRecordingSource$ = toObservable(this.cardInfo).pipe(
      switchMap((cardInfo) => {
        if (!cardInfo.callRecordingUrl) {
          return of(null);
        }
        return this.http.get(cardInfo.callRecordingUrl, {
          responseType: 'text',
          withCredentials: true,
        });
      }),
    );
  }
}

interface ActivityCardInformation {
  body: string;
  outcome: string;
  status: string;
  callRecordingUrl?: string;
}
